import { render, staticRenderFns } from "./GroupWizardList.vue?vue&type=template&id=3ff84a0c&scoped=true&"
import script from "./GroupWizardList.vue?vue&type=script&lang=ts&"
export * from "./GroupWizardList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupWizardList.vue?vue&type=style&index=0&id=3ff84a0c&lang=scss&scoped=true&"
import style1 from "./GroupWizardList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff84a0c",
  null
  
)

export default component.exports